// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "processed_webhook_event".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "processed_webhook_event" table (1:1 with a DB row, on the wire). */
export const processedWebhookEventAtomSchema = z.object({
    provider: z.string(),
    eventId: z.string(),
    processedAt: z.string().datetime(),
});
//# sourceMappingURL=processedWebhookEvent.js.map